import AssessmentGroupManager from './AssessmentGroupManager.container';

export default AssessmentGroupManager;
